import { forEach as _forEach } from 'lodash';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col, Image, Clearfix } from 'react-bootstrap';

import PositionsInfos from 'components/layout/PositionsInfos';
import SalesDocumentSummary from 'components/layout/SalesDocumentSummary';
import IntlDate from 'components/layout/IntlDate';
import InvoiceAuthorizeButton from 'components/layout/financial/InvoiceAuthorizeButton';

import RichEditorContent from 'components/RichEditorContent';

class InvoiceView extends React.Component {
  readData = field => {
    if (field !== undefined) {
      return field;
    }

    return '';
  };

  getClientData = data => {
    return {
      company: this.readData(data.company),
      firstName: this.readData(data.first_name),
      lastName: this.readData(data.last_name),
      street: this.readData(data.street),
      houseNumber: this.readData(data.house_number),
      apartmentNumber: this.readData(data.apartment_number),
      addressLine2: this.readData(data.address_line2),
      zipCode: this.readData(data.zip_code),
      city: this.readData(data.city),
      vatIdName: this.readData(data.vat_id_name),
      vatId: this.readData(data.vat_id),
    };
  };

  getOwnerData = () => {
    const { data } = this.props;
    return this.getClientData(data.owner_data);
  };

  usesTargetOrganisation = () => {
    const { data } = this.props;
    return !!data.target_organisation_data;
  };

  showTargetData = (targetData, vatIdName) => {
    return (
      <>
        {!!targetData.company && <strong>{targetData.company}</strong>}
        {targetData.company ? <br /> : null}
        {targetData.firstName} {targetData.lastName}
        <br />
        {targetData.street} {targetData.houseNumber} {targetData.apartmentNumber}
        <br />
        {targetData.addressLine2 ? (
          <>
            {targetData.addressLine2}
            <br />
          </>
        ) : null}
        {targetData.zipCode} {targetData.city}
        <br />
        {!!targetData.company && (
          <span>
            {vatIdName} {targetData.vatId}
          </span>
        )}
      </>
    );
  };

  render() {
    const {
      intl: { messages },
      data,
    } = this.props;

    const {
      is_auto_generated: isAutoGenerated,
      is_authorized: isAuthorized,
      authorized_on: authorizedOn,
      authorized_by_name: authorizedByName,
    } = data;

    const ownerData = this.getOwnerData();
    const usesTargetOrganisation = this.usesTargetOrganisation();

    let orders_order_number = '';
    _forEach (data.orders, (order, i) => {
      orders_order_number += ((i > 0) ? ', ' : '') + order.id;
    });
    let debtor_number = '';
    if (data.target_organisation && data.target_organisation.ident) {
      debtor_number = data.target_organisation.ident.debtor_number;
    } else if (data.target && data.target.ident) {
      debtor_number = data.target.ident.debtor_number;
    }
    if (data?.target_organisation?.alternative_effective_debtor_number) {
      debtor_number = data.target_organisation.alternative_effective_debtor_number;
    }else if (data?.target?.alternative_effective_debtor_number) {
      debtor_number = data.target.alternative_effective_debtor_number;
    }

    return (
      <Clearfix>
        {!isAutoGenerated && (
          <div className="p-t-20 p-b-30">
            {isAuthorized ? (
              <FormattedMessage
                id="authorized_by_name_on_date"
                values={{ name: authorizedByName, date: <IntlDate date={authorizedOn} /> }}
              />
            ) : (
              <InvoiceAuthorizeButton invoiceId={data.id} />
            )}
          </div>
        )}

        {/*<header className="m-b-10">
          <h4>{messages.salesDoc.invoice.toUpperCase()}</h4>
        </header>*/}

        <Col xs={12} md={6}>
          <div>
            {!!data.owner_logo && (
              <Image src={data.owner_logo} responsive style={{ maxHeight: '100px', maxWidth: '200px' }} />
            )}
          </div>
          <p>&nbsp;</p>
          <Row>
            <Col xs={3}>
              <div className="text-right">{messages.salesDoc.invoice}</div>
            </Col>
            <Col xs={9}>
              <strong>
                #{data.number_prefix || ''}
                {data.number || '?'}
              </strong>
            </Col>
          </Row>
          {!!debtor_number && (
            <Row>
              <Col xs={3}>
                <div className="text-right">{messages.salesDoc.debtor_number}</div>
              </Col>
              <Col xs={9}>
                #{debtor_number}
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={3}>
              <div className="text-right">{messages.salesDoc.order_number}</div>
            </Col>
            <Col xs={9}>
              #{orders_order_number}
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <div className="text-right">{messages.salesDoc.issued}</div>
            </Col>
            <Col xs={9}>
              <IntlDate date={data.cdate} />
            </Col>
          </Row>
          {!!data.period && !!data.period.date_from && !!data.period.date_to && (
            <Row>
              <Col xs={3}>
                <div className="text-right">{messages.salesDoc.billing_period}</div>
              </Col>
              <Col xs={9}>
                <IntlDate date={data.period.date_from} /> - <IntlDate date={data.period.date_to} />
              </Col>
            </Row>
          )}
          {!!data.delivery_date && (
            <Row>
              <Col xs={3}>
                <div className="text-right">{messages.delivery_date}</div>
              </Col>
              <Col xs={9}>
                <IntlDate date={data.delivery_date} />
              </Col>
            </Row>
          )}
        </Col>

        <Col xs={12} md={6}>
          <Row>
            <Col xs={6}>
              <div className="text-right">{messages.salesDoc.invoice_from}</div>
            </Col>
            <Col xs={6}>
              <strong>{ownerData.company}</strong>
              <br />
              {ownerData.firstName} {ownerData.lastName}
              <br />
              {ownerData.street} {ownerData.houseNumber} {ownerData.apartmentNumber}
              <br />
              {ownerData.addressLine2 ? (
                <>
                  {ownerData.addressLine2}
                  <br />
                </>
              ) : null}
              {ownerData.zipCode} {ownerData.city}
              <br />
              {ownerData.vatIdName} {ownerData.vatId}
            </Col>
          </Row>

          <p>&nbsp;</p>
          <Row>
            <Col xs={6}>
              <div className="text-right">{messages.salesDoc.invoice_for}</div>
            </Col>
            <Col xs={6}>
              {this.showTargetData(
                this.getClientData(usesTargetOrganisation ? data.target_organisation_data : data.target_data),
                ownerData.vatIdName
              )}
            </Col>
          </Row>

          {usesTargetOrganisation && (
            <>
              <p>&nbsp;</p>
              <Row>
                <Col xs={6}>
                  <div className="text-right">{messages.client}</div>
                </Col>
                <Col xs={6}>{this.showTargetData(this.getClientData(data.target_data), ownerData.vatIdName)}</Col>
              </Row>
            </>
          )}
        </Col>

        <Row>
          <Col xs={12}>
            <h2>{messages.salesDoc.invoice}</h2>
            <PositionsInfos doc={data} />
          </Col>
          <Col xs={7} xsOffset={5}>
            <SalesDocumentSummary doc={data} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} style={{ paddingTop: '15px' }}>
            <RichEditorContent content={data?.terms_of_payment} />
          </Col>
        </Row>

        {!!data.comment && (
          <Row>
            <Col xs={6}>
              <RichEditorContent content={data.comment} />
            </Col>
          </Row>
        )}
      </Clearfix>
    );
  }
}

export default injectIntl(InvoiceView);
